export const AuthActionTypes = {
  SET_LOADING_STATE: 'SET_AUTH_LOADING_STATE',
  SET_NEW_ACCESS_TOKEN: 'SET_NEW_ACCESS_TOKEN',
  UPDATE_AUTH_STATE: 'UPDATE_AUTH_STATE',
  SET_MESSAGE_DIALOG: 'SET_AUTH_MESSAGE_DIALOG'
}

export const AuthStates = {
  UNDEFINED: 'UNDEFINED',
  AUTHENTICATED: 'AUTHENTICATED',
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED'
}
